export default __webpack_public_path__ + "static/media/log.e879a8a1.svg";